export default __webpack_public_path__ + "c6892a7c26ed37543b89d7d445d567bf.png";